import classNames from 'classnames';
import React from 'react';

import { Nav } from '@feathr/components';

import styles from './TertiaryNav.css';

interface IProps {
  className?: string;
  children: React.ReactNode;
  label: string;
}

function TertiaryNav({ children, className, label }: IProps) {
  return (
    <Nav className={classNames(styles.root, className)} label={label} type={'vertical'}>
      {children}
    </Nav>
  );
}

export default TertiaryNav;
